// -------------Custom Components ---------------//
export { default as MainArea } from '@/components/main-area';
export { default as Modal } from '@/components/modal';
export {axios, API, Loading, SUCCESS_REPONSE_CODE, useRouter, getSession, useState, useTranslation, UNPROCESSABLE_ENTITY_RESPONSE_CODE, handleOtherResponseCode,  toastr, UNAUTHORIZED_REPONSE_CODE, useEffect, TRANSLATION, Yup} from '@/imports-files/common/common';
// -------------Custom Components ---------------//


// -------------SERVICES ---------------//
export {SendRequest} from '@/services/common/send-request';
export {IntegrationConnect} from '@/services/pages/clients/activities/integration-connected';
// -------------SERVICES ---------------//


// -------------PAGES ---------------//
export {authorizeUser} from '@/actions/pages/clients/activities/integration-connected';
// -------------PAGES ---------------//
